export const ADD_FLEX = "ADD_FLEX"
export const REMOVE_FLEX = "REMOVE_FLEX"

export const addFlex = flex => ({
  payload: { flex },
  type: ADD_FLEX
})

export const removeFlex = flex_id => ({
  payload: { flex_id },
  type: REMOVE_FLEX
})

export const flexUsed = flex => (dispatch, getState) => {
  dispatch(addFlex(flex))

  const { flexes: { duration } } = getState()

  setTimeout(() => dispatch(removeFlex(flex.id)), duration)
}